module.exports = __webpack_public_path__ + "static/media/ideal.752c2f03.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/ideal.png
// module id = 215
// module chunks = 0